import * as React from 'react';
import { ERouteControlViewType } from '@cian/frontend-newbuilding-map-component';
import { IInfrastructureItem, IInfrastructureProps, trackRouteButtonClick, trackRouteSuccess } from '../utils';
import { useIsDesktop } from '@cian/valuation-utils-component';

interface IUseRouteButtonProps {
  mapRef: IInfrastructureProps['mapRef'];
  centeredCoordinates: IInfrastructureProps['centeredCoordinates'];
}

interface IIUseRouteButtonResponse {
  startBuildingRoute: (item?: IInfrastructureItem) => void;
  isRouteMode: boolean;
  handleRouteModeEnter: () => void;
  handleRouteModeExit: () => void;
  handleRouteSuccess: () => void;
}

export const useRouteButtonProps = ({
  mapRef,
  centeredCoordinates,
}: IUseRouteButtonProps): IIUseRouteButtonResponse => {
  const isDesktop = useIsDesktop();
  const viewType = isDesktop ? ERouteControlViewType.default : ERouteControlViewType.stickyBottom;

  const [isRouteMode, setRouteMode] = React.useState(false);

  const handleRouteModeEnter = React.useCallback(() => {
    setRouteMode(true);
    trackRouteButtonClick();
  }, []);

  const handleRouteModeExit = React.useCallback(() => {
    setRouteMode(false);
  }, []);

  const handleRouteSuccess = React.useCallback(() => {
    trackRouteSuccess();
  }, []);

  const startRouting = React.useCallback(
    (geoItem?: IInfrastructureItem) => {
      const from = {
        coordinates: centeredCoordinates,
        fixed: true,
      };

      const to = geoItem ? { coordinates: geoItem.coordinates } : undefined;

      mapRef.current?.startRouting(
        from,
        to,
        'properties.name === "main" && geometry.type === "Polygon"',
        undefined,
        viewType,
      );
    },
    [centeredCoordinates],
  );

  const startBuildingRoute = React.useCallback(
    (item?: IInfrastructureItem) => {
      startRouting(item);
    },
    [startRouting],
  );

  return {
    startBuildingRoute,
    isRouteMode,
    handleRouteModeEnter,
    handleRouteModeExit,
    handleRouteSuccess,
  };
};
